export const SITE = {
  name: "Top Email Marketing Tools",
  tagline: "Find Your Perfect Email Marketing Platform",
  domain: "topemailmarketingtools.com",
};

export const DISCLOSURE_SHORT =
  "Affiliate Disclosure: This page contains affiliate links. If you purchase through our links, we may earn a commission at no extra cost to you. Our rankings are based on hands-on testing and independent research.";

export const DISCLOSURE_FTC =
  "Top Email Marketing Tools is reader-supported. When you buy through links on our site, we may earn an affiliate commission. This compensation may impact how and where products appear on this site, but it never influences our editorial scores, which are based on independent testing. We comply with FTC 16 CFR Part 255 guidelines on endorsements and testimonials.";

export const MARQUEE_ITEMS = [
  "Honest Reviews",
  "Data-Driven Comparisons",
  "Tested & Verified",
  "Updated for 2026",
  "No Sponsored Rankings",
  "Built for Small Business",
];

export const HOME_FAQ = [
  {
    q: "What is the best email marketing software for small businesses in 2026?",
    a: "For most small businesses, GetResponse is the best overall pick in 2026 because it combines email, automation, landing pages, and webinars in one affordable plan. If budget is your top concern, MailerLite offers the best value, and if you sell digital products or run a newsletter, ConvertKit (now Kit) is purpose-built for creators.",
  },
  {
    q: "Which email platform has the best free plan?",
    a: "ConvertKit's free Newsletter plan supports up to 10,000 subscribers, making it the most generous free tier in 2026. MailerLite's free plan covers 1,000 subscribers with automation included, and GetResponse offers a free plan for up to 500 contacts with a website builder included.",
  },
  {
    q: "How much should a small business spend on email marketing?",
    a: "Most small businesses spend between $15 and $80 per month depending on list size. The industry benchmark return is $36-$42 for every $1 spent, so even a $50/month platform only needs to generate a handful of extra sales to pay for itself. Start on a free plan, then upgrade once your list passes 500-1,000 engaged subscribers.",
  },
  {
    q: "What matters more: features or deliverability?",
    a: "Deliverability. A platform with 200 features is worthless if your emails land in spam. All five platforms we recommend maintain strong sender reputations and authentication support (SPF, DKIM, DMARC), but GetResponse and AWeber consistently score highest in independent deliverability tests.",
  },
  {
    q: "Can I switch email platforms without losing my list?",
    a: "Yes. Every platform on this page supports CSV imports, and most offer free migration concierge services that move your subscribers, tags, and automations for you. Expect a migration to take 1-3 days. Always export a backup of your list and suppression (unsubscribe) data before switching.",
  },
  {
    q: "Do I need marketing automation as a beginner?",
    a: "You need three automations from day one: a welcome sequence, an abandoned cart or follow-up flow, and a re-engagement campaign. These three workflows typically drive 30-50% of all email revenue for small businesses. Every platform we review includes at least basic automation, even on entry plans.",
  },
];

export const CHECKLIST_ITEMS = [
  "Define your primary list-building goal and lead magnet",
  "Set up SPF, DKIM, and DMARC authentication records",
  "Build a 5-email welcome automation sequence",
  "Segment subscribers by source and interest from day one",
  "Design a mobile-first email template with one clear CTA",
  "Establish a consistent sending cadence (and stick to it)",
  "A/B test subject lines on every campaign for 90 days",
  "Prune inactive subscribers every quarter",
  "Track revenue per email, not just open rates",
  "Review deliverability metrics monthly",
];

export const NAV = {
  reviews: { label: "Reviews", href: "/#top-picks" },
  hubs: { label: "Best For", href: "/#best-for" },
};
